import type { AllRouteEndpoints } from "../routeTypes";
export const engagementApprovalsContextIdApproveAllCacheKeys: AllRouteEndpoints[] = [
  "/engagement/approvals/:context_id/(:step)",
];
